
import {Vue, Component} from 'vue-property-decorator';
import {getSuppliersList} from "@/api/inquiry";
import {CreateClaim, getClaimReason, getCreateDetails, getDeductionMethod} from "@/api/credit-note";

@Component({
  name: 'EditClaimForm',
})
export default class extends Vue {
  private show = false;
  private edit = false;
  private claimId = "";
  private deductionMethod = "";
  private deductionMethodOptions = [];
  private claimReason = "";
  private claimReasonOptions = [];
  private supplierId = "";
  private supplierOptions = [];
  private searchSupplierLoading = false;
  private timeOfIssue = "";
  private claimInfoFrom = {
    claimProducts: "",
    purchaseOrders: "",
    oeNumberDesc: "",
    hqNumberDesc: "",
    refNumberDesc: "",
    claimNumber: 0,
    reasonForComplaint: "",
    claimAmount: 0,
    supplierProcessingResults: "",
    supplierConfirmingPersonnel: "",
    supplierConfirmationDate: "",
    remark: "",
  } as any;
  private claimInfo = [
    {
      label: "产品名称",
      key: "claimProducts",
    },
    {
      label: "采购订单号码",
      key: "purchaseOrders",
    },
    {
      label: "产品OE",
      key: "oeNumberDesc",
      type: "input",
    },
    {
      label: "产品华强号码",
      key: "hqNumberDesc",
      type: "input",
    },
    {
      label: "产品参照号码",
      key: "refNumberDesc",
      type: "input",
    },
    {
      label: "投诉数量",
      key: "claimNumber",
      type: "inputNumber",
    },
    {
      label: "投诉原因",
      key: "reasonForComplaint",
      type: "textarea",
      maxlength: 64
    },
    {
      label: "客人索赔要求（索赔金额）",
      key: "claimAmount",
      type: "inputNumber",
      precision: 2
    },
    {
      label: "供应商处理结果",
      key: "supplierProcessingResults",
      type: "input",
      maxlength: 64
    },
    {
      label: "供应商确认人员",
      key: "supplierConfirmingPersonnel",
      type: "input",
      maxlength: 64
    },
    {
      label: "供应商确认日期",
      key: "supplierConfirmationDate",
      type: "datetime",
    },
    {
      label: "备注",
      key: "remark",
      type: "textarea",
      maxlength: 512
    },
  ] as any;

  created() {
    this.getDeductionMethod();
    this.getClaimReason();
  }

  private async getDeductionMethod() {
    this.deductionMethodOptions = await getDeductionMethod() as any;
  }

  private async getClaimReason() {
    this.claimReasonOptions = await getClaimReason() as any;
  }

  public async openDialog(id, isEdit = false) {
    this.show = true;
    this.edit = isEdit;
    this.claimId = id;
    const res = await getCreateDetails(id) as any;
    this.claimInfoFrom = res;
    this.deductionMethod = res.deductionMethod ? res.deductionMethod : "";
    this.claimReason = res.claimReason ? res.claimReason : "";
    this.timeOfIssue = res.timeOfIssue ? res.timeOfIssue : "";
    this.supplierId = res.supplierId ? res.supplierId : "";
    await this.getSuppliersList(res.supplierAbb);
  }

  private async getSuppliersList(query) {
    this.searchSupplierLoading = true;
    this.supplierOptions = await getSuppliersList({ abbreviation: query }) as any;
    this.searchSupplierLoading = false;
  }

  private handleChange(e) {
    if (e.length > 0) {
      this.claimReason = e[e.length - 1];
    }
  }

  private async createClaim(confirm: boolean) {
    if (this.deductionMethod === "") {
      this.$notify({
        title: "提示",
        message: "抵扣方式不能为空",
        type: "error",
        duration: 2000,
      });
      return;
    }
    if (this.claimReason === "") {
      this.$notify({
        title: "提示",
        message: "索赔原因不能为空",
        type: "error",
        duration: 2000,
      });
      return;
    }
    if (this.supplierId === "") {
      this.$notify({
        title: "提示",
        message: "供应商不能为空",
        type: "error",
        duration: 2000,
      });
      return;
    }
    if (this.timeOfIssue === "") {
      this.$notify({
        title: "提示",
        message: "签发时间不能为空",
        type: "error",
        duration: 2000,
      });
      return;
    }
    if (this.claimInfoFrom.claimAmount === "") {
      this.$notify({
        title: "提示",
        message: "客人索赔要求不能为空",
        type: "error",
        duration: 2000,
      });
      return;
    }
    this.claimInfoFrom.deductionMethod = this.deductionMethod;
    this.claimInfoFrom.claimReason = this.claimReason;
    this.claimInfoFrom.supplierId = this.supplierId;
    this.claimInfoFrom.supplierAbb =
        this.supplierOptions.find(item => item.id === this.claimInfoFrom.supplierId)?.abbreviation?? "";
    this.claimInfoFrom.timeOfIssue = this.timeOfIssue;
    if (confirm) {
      this.claimInfoFrom.confirm = true;
      this.$confirm(
          "请确认抵扣方式、索赔原因、数量和索赔金额无误，确定后索赔单将流转成可抵扣的状态!若未确定请点击保存.",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(async () => {
            await CreateClaim(this.claimId, this.claimInfoFrom)
                .then(async () => {
                  this.$notify({
                    title: "成功",
                    message: "生成索赔单成功",
                    type: "success",
                    duration: 2000,
                  });
                  this.show = false;
                  this.$emit("refresh");
                })
                .catch((errs) => {
                  console.log(errs);
                });
          })
          .catch((err) => {
            console.error(err);
          });
    } else {
      this.claimInfoFrom.confirm = false;
      await CreateClaim(this.claimId, this.claimInfoFrom)
          .then(async () => {
            this.$notify({
              title: "成功",
              message: "保存索赔单成功",
              type: "success",
              duration: 2000,
            });
            this.show = false;
            this.$emit("refresh");
          })
          .catch((errs) => {
            console.log(errs);
          });
    }
  }
}
